import { render, staticRenderFns } from "./become-partner.vue?vue&type=template&id=1a9c927c&scoped=true&"
import script from "./become-partner.vue?vue&type=script&lang=js&"
export * from "./become-partner.vue?vue&type=script&lang=js&"
import style1 from "./become-partner.vue?vue&type=style&index=1&id=1a9c927c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c927c",
  null
  
)

export default component.exports